<template>
  <div>
    <van-nav-bar
      style="background: #ffffff; color: #323233; font-weight: bold"
      fixed
      title="新建退货单"
      left-arrow
      @click-left="onClickLeft"
    />
    <div id="aaa"></div>

    <van-cell-group title="影像中心" :border="false" style="margin-left: 10px">
      <van-cell
        icon="location-o"
        :title="currentAgent.name"
        is-link
        @click="toPwalist"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>
    <van-cell-group title="采购订单" :border="false" style="margin-left: 10px">
      <van-cell
        icon="orders-o"
        :title="purchaseOrderNum"
        is-link
        @click="toOrderList"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>

    <van-cell-group title="备注" :border="false" style="margin-left: 10px">
      <van-cell icon="edit" style="border-bottom: 0.1px solid #f5f5f5">
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="请输入备注信息"
          show-word-limit
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group title="退货明细" :border="false">
      <van-cell class="haha">
        <van-cell v-if="returnDetail[0]">
          <van-swipe-cell
            v-for="(item, index) in returnDetail"
            :key="index"
            style="border-bottom: 0.2px solid #dcdcdc"
          >
            <van-row class="ha" type="flex">
              <van-col span="24">{{ item.model_name }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="8">
                <span style="color: #969799">采购数量:</span>
                <span style="color: #323233; font-weight: bold">{{
                  item.quantity
                }}</span>
              </van-col>
            </van-row>
            <van-row type="flex">
              <van-col span="24">
                <span style="color: #969799">退货数量:</span>
                <input
                  type="text"
                  v-model="item.rknum"
                  style="
                    width: 75%;
                    height: 50%;
                    color: #323233;
                    font-weight: bold;
                  "
                />
              </van-col>
            </van-row>
            <van-button
              style="height: 100%"
              slot="right"
              square
              text="删除"
              type="danger"
              class="delete-button"
              @click="del(index)"
            />
          </van-swipe-cell>
        </van-cell>
      </van-cell>
      <van-cell>
        <van-icon
          v-if="purchaseOrderNum != '暂无订单' && orderDetail[0]"
          name="add-o"
          color="#07c160"
          size="40"
          @click="add"
          style="float: right"
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group>
      <van-cell>
        <van-row type="flex">
          <van-col span="10">
            <van-button
              round
              type="info"
              @click="bc"
            >保存</van-button>
          </van-col>
          <van-col span="2"></van-col>
          <van-col span="10">
            <van-button
              round
              type="info"
              @click="qr"
            >提交</van-button>
          </van-col>
          
        </van-row>
      </van-cell>
    </van-cell-group>
    <div
      v-show="bottom_tip"
      style="font-size: 10px; text-align: center; padding: 10px 10px"
    >
      ©2020 一脉阳光集团信息中心
    </div>
    <van-dialog
      v-model="show"
      title="请仔细核查"
      show-cancel-button
      @confirm="qrtj"
    >
      <van-cell-group title="影像中心" :border="false">
        <van-cell :title="currentAgent.name" />
      </van-cell-group>
      <van-cell-group title="退货明细" :border="false">
        <van-cell v-for="(item, index) in returnDetail" :key="index">
          <van-row type="flex">
            <van-col span="6">耗材型号：</van-col>
            <van-col span="18">{{ item.model_name }}</van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="6">退货数量：</van-col>
            <van-col span="18">{{ item.rknum }}</van-col>
          </van-row>
        </van-cell>
      </van-cell-group>
    </van-dialog>
  </div>
</template>
<script>
import {
  SwipeCell,
  Icon,
  NavBar,
  Tag,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  Panel,
  Divider,
  Button,
  Dialog,
  Toast,
  Uploader,
} from "vant";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [SwipeCell.name]: SwipeCell,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]: Panel,
    [Divider.name]: Divider,
    [Row.name]: Row,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      show: false,
      //备注信息
      message: "",
      bottom_tip: true,
      //obj 选中的影像中心的所有采购订单
      purchaseOrderInfo: "",
      //选中的订单的明细
      orderDetail: [],
      //退货的明细
      returnDetail: [],
      //当前选中的订单
      purchaseOrderNum: "",
      //当前选中的影像中心
      currentAgent: "",
      //公司编码
      companyErpCode:"",
      //供应商编码
      vendorCode:"",
      //保存还是提交
      flag:"",
    };
  },

  methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),
    onClickLeft() {
      this.$router.push("salesreturn");
    },
    add() {
      //window.console.log(this.orderDetail);
      this.$router.push({
        name: "returnorderdetail",
        params: {
          orderDetail: this.orderDetail,
          orderNum: this.purchaseOrderNum,
          confirmDetail: this.returnDetail,
          message: this.message,
          refer: "addsalesreturn",
        },
      });
    },
    del(index) {
      //window.console.log(index);
      this.returnDetail.splice(index,1);
    },
    bc() {
      this.show = true;
      this.flag = "1";
    },
    qr() {
      this.show = true;
      this.flag = "2";
    },
    qrtj() {
      let that = this;
      if (!this.returnDetail[0]) {
        Toast("明细不能为空");
        return;
      }

      let result = this.parseSubmitData(this.returnDetail);
      //window.console.log(result);
      if (result.message) {
        Toast(result.message);
        return;
      } else {
        if (result.data[0]) {
          let data = {
            purchase_order_num: this.purchaseOrderNum,
            project_erp_code: this.currentAgent.erp_code,
            company_erp_code: this.companyErpCode,
            vendor_code: this.vendorCode,
            creater: localStorage.getItem("usermobile"),
            remark: this.message ? this.message : "退货申请",
            currentnode: this.flag,
            detail: result.data,
          };
          //window.console.log(data);
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
          });

          this.$http({
            method: "post",
            url: "/mobile/returngoods/createReturnGoodsOrder",
            data,
          }).then(function (response) {
            if (response.state == 200) {
              Toast.success("新建成功");
              //window.console.log(response);
              that.$router.push("salesreturn");
            }
          });
        } else {
          Toast("入库数量不能全部为空");
          return;
        }
      }
    },
    parseSubmitData(obj) {
      let newarr = [];
      let message = "";
      for (let i = 0; i < obj.length; i++) {
        if (!obj[i].rknum || obj[i].rknum == 0) {
          continue;
        }
        if (obj[i].rknum.match(/\D/g)) {
          let num = i + 1;
          message =
            message + "第" + num + "条明细,退货数量包含非数字字符或空格！\n";
        }
        if (obj[i].rknum && obj[i].rknum > obj[i].quantity) {
          let num = i + 1;
          message =
            message + "第" + num + "条明细,退货数量不能超过采购数量！\n";
        }

        let newobj = {
          detail_id: obj[i].detail_id,
          brand_uuid: obj[i].brand_uuid,
          model_uuid: obj[i].model_uuid,
          unit: obj[i].unit,
          quantity: obj[i].rknum || "0",
          tax_unit_price: obj[i].tax_unit_price,
          warehouse_id: obj[i].warehouse_id,
          old_quantity: obj[i].quantity,
        };
        newarr.push(newobj);
      }
      return {
        message: message,
        data: newarr,
      };
    },
    toPwalist() {
      this.$router.push("/pwalist");
    },
    toOrderList() {
      //window.console.log(this.purchaseOrderInfo);
      this.$router.push({
        name: "returnorderlist",
        params: {
          info: this.purchaseOrderInfo,
          ordernum: this.purchaseOrderNum,
          message:this.message,
        },
      });
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
  },

  created() {
    if (this.permissionAgent) {
      this.returnDetail = this.$route.params.confirmDetail
        ? this.$route.params.confirmDetail
        : [];
      this.message = this.$route.params.message
        ? this.$route.params.message
        : "";
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function (item) {
        return item.id == _this.defaultAgentIndex;
      });
      this.$http
        .post("/mobile/returngoods/getOrderNumByProjectCode", {
          projectErpCode: this.currentAgent.erp_code,
        })
        .then(function (response) {
          if (response) {
            _this.purchaseOrderInfo = response.purchase_order_num;
            if (!response.purchase_order_num[0]) {
              _this.purchaseOrderNum = "暂无订单";
            } else {
              _this.purchaseOrderNum =
                _this.$route.params.ordernum ||
                response.purchase_order_num[0].purchase_order_num;
              _this.$http
                .post("/mobile/returngoods/getOrderDetailByNum", {
                  projectErpCode: _this.currentAgent.erp_code,
                  purchaseOrderNum: _this.purchaseOrderNum,
                })
                .then(function (response) {
                  if (response.data.detail) {
                    _this.vendorCode = response.data.vendor_code;
                    _this.companyErpCode = response.data.company_erp_code;
                    _this.orderDetail = response.data.detail;
                  }
                });
            }
          }
        });
    } else {
      this.returnDetail = this.$route.params.confirmDetail
        ? this.$route.params.confirmDetail
        : [];
      this.message = this.$route.params.message
        ? this.$route.params.message
        : "";
      let _this = this;
      this.$http
        .post("/mobile/rimsAgentList", {
          username: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          if (response) {
            _this.changePermissionAgent(response.rimsAgent);
            _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
            _this.currentAgent = _this.permissionAgent.find(function (item) {
              return item.id == _this.defaultAgentIndex;
            });
            _this.$http
              .post("/mobile/returngoods/getOrderNumByProjectCode", {
                projectErpCode: _this.currentAgent.erp_code,
              })
              .then(function (response) {
                if (response) {
                  _this.purchaseOrderInfo = response.purchase_order_num;
                  if (!response.purchase_order_num[0]) {
                    _this.purchaseOrderNum = "暂无订单";
                  } else {
                    _this.purchaseOrderNum =
                      _this.$route.params.ordernum ||
                      response.purchase_order_num[0].purchase_order_num;
                    _this.$http
                      .post("/mobile/returngoods/getOrderDetailByNum", {
                        projectErpCode: _this.currentAgent.erp_code,
                        purchaseOrderNum: _this.purchaseOrderNum,
                      })
                      .then(function (response) {
                        if (response.data.detail) {
                          _this.vendorCode = response.data.vendor_code;
                          _this.companyErpCode = response.data.company_erp_code;
                          _this.orderDetail = response.data.detail;
                        }
                      });
                  }
                }
              });
          }
        });
    }
  },
};
</script>
<style scoped lang="less">
.van-nav-bar__title {
  font-weight: 800;
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}

.haha .van-cell {
  line-height: 1.2rem !important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
}
.ha {
  font-weight: bold;
}

.van-tag {
  margin-left: 2%;
}

.van-button {
  width: 100%;
}
#aaa {
  width: 100vw;
  height: 46px;
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: rgba(0, 0, 0, 0.7);
}
.van-tag--default {
  background-color: #f7f8fa;
}
.choiceWarhouse .van-tag {
  padding: 0.6em 1.5em !important;
  /*font-weight: bold;*/
  font-size: 0.4rem;
  margin: 0.2em;
  color: #323233;
  border-radius: 10px;
}
.van-cell-group__title {
  color: #323233 !important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell {
  color: #969799 !important;
}
.van-tag--danger.van-tag--plain {
  color: rgb(131, 134, 131);
}
.upload-img {
  display: flex;
  flex-wrap: wrap;
}
.img-box {
  width: 88px;
  height: 88px;
  margin-right: 8px;
  margin-bottom: 8px;
}
.image {
  width: 88px;
  height: 88px;
}
</style>